import { useEffect, useRef } from 'react';

export function useClickOutside(handler) {
  let ref = useRef(null);

  // a issue with 'toggle on/off' button mixed with 'toggle off' in the
  // useClickOutside handler:
  // in the cases where we wish to press a toggle button outside the elem
  // handled by useClickOutside the useClickOutside handler, called in the
  // same tick as the toggle button's onClick, is ran and potentially
  // changing the visibility state for a component and then make the toggle
  // button in the instance one presses it change the state from being
  // a **toggle off** to being a **toggle on** button.
  useEffect(() => {
    /** @param {MouseEvent} event */
    const listener = event => {
      if (!ref.current || ref.current.contains(event.target)) {
        return;
      }

      handler(event);
    };

    document.addEventListener('click', listener, { capture: true });
    return () => {
      document.removeEventListener('click', listener);
    };
  }, [handler]);

  return ref;
}
